import { inject, signal, WritableSignal } from "@angular/core";
import type { AccountManualType } from "@bitwarden/web-vault/app/models/types/account.types";
import { CalculationTodayStoreService } from "@bitwarden/web-vault/app/services/store/calculation-today/calculation-today.store.service";
import { ImportStoreService } from "@bitwarden/web-vault/app/services/store/import/import.store.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";

import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { TransactionStoreService } from "@bitwarden/web-vault/app/services/store/transaction/transaction.store.service";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { EarnTableView } from "@bitwarden/web-vault/app/models/types/transaction.types";
import { SignalSubscriptionImpl } from "@bitwarden/web-vault/app/components/tables/data-subscription";
import { getTransactionRedactionTableViews } from "@bitwarden/web-vault/app/components/tables/earn-tables/earn.table";

// todo move types to a separate file
export type TableSource = EarnTableView;
export type TableFilter = { [key in AccountManualType]: boolean };

/**
 * This class only need to deal with angular dependency
 * and the core logic is in getAccountTableViews function which can be easily unit tested
 */

export class EarnViewTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  protected filter: WritableSignal<TableFilter> = signal<TableFilter>(null);
  userStoreService: UserStoreService;
  importStoreService: ImportStoreService;
  calculationStoreService: CalculationTodayStoreService;
  transactionStore: TransactionStoreService;
  earnService: EarnService;

  constructor() {
    super();
    this.userStoreService = inject(UserStoreService);
    this.importStoreService = inject(ImportStoreService);
    this.calculationStoreService = inject(CalculationTodayStoreService);
    this.transactionStore = inject(TransactionStoreService);
    this.earnService = inject(EarnService);
  }

  get source() {
    if (!this.earnService.selectedMask()) {
      return [];
    }
    const institutionViews = this.userStoreService.institutions.institutionViews();
    let transactions = this.transactionStore.enrichTransaction.collection();
    const accountViews = this.userStoreService.enrichAccounts.collection();

    if (this.earnService.selectedMask().status === "published") {
      transactions = transactions.filter((t: TransactionView) =>
        this.earnService.selectedMask().appliedToArray.includes(t.id),
      );
    }
    return getTransactionRedactionTableViews(
      accountViews,
      transactions,
      institutionViews,
      this.earnService.selectedMask(),
    );
  }
}
